import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowIdPage.MatrixPopupContent.AmountConditionHeader', {
    amount: 'Amount ({ currency })',
    totalAmount: 'Total amount ({currency})',
    netAmount: 'Net amount ({currency})',
});
